import { AnimatePresence, motion } from "framer-motion";
import React, { useState } from "react";
import { FaTriangleExclamation, FaXmark } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { setUnsubModal } from "../store/slices/unsubModalSlice";
import classes from "./UnsubModal.module.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { removeUser } from "../store/slices/userSlice";
import { unsubApi } from "../http/http";
import SmallLoader from "../component/SmallLoader";
import { toast } from "react-toastify";

const UnsubModal = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state?.persisted?.userSlice);
  const [loading, setLoading] = useState(true);
  const closeModal = () => {
    dispatch(setUnsubModal(false));
  };

  const confirmUnsubscribe = async () => {
    console.log("unsubscribe confirmed menu");
    setLoading(true);
    await unsubApi(user?.token)
      .then((res) => {
        setLoading(false);
        dispatch(removeUser());
        closeModal();
        navigate("/");
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        toast.error(t("errorMsg"));
      });
  };

  return (
    <AnimatePresence>
      <motion.div
        className={classes.modalOverlay}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={closeModal}
      >
        <motion.div
          className={classes.modalBox}
          initial={{ opacity: 0, y: 30, scale: 0.94 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.96 }}
          transition={{ duration: 0.25, ease: "easeOut" }}
          onClick={(e) => e.stopPropagation()}
        >
          <button className={classes.modalCloseBtn} onClick={closeModal}>
            <FaXmark />
          </button>

          <div className={classes.modalIconWrap}>
            <FaTriangleExclamation />
          </div>

          <h3 className={classes.modalTitle}>{t("108")}</h3>

          <p className={classes.modalText}>{t("109")}</p>

          <div className={classes.modalActions}>
            <button className={classes.modalCancelBtn} onClick={closeModal}>
              {t("110")}
            </button>

            <button
              className={classes.modalConfirmBtn}
              onClick={confirmUnsubscribe}
              disabled={loading}
            >
              {loading ? (
                <SmallLoader style={{ border: "5px solid #fff" }} />
              ) : (
                t("111")
              )}
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default UnsubModal;
